// @WARNING This state should only be used in the current directory

import { IUserServiceState } from "./model"

export const state: IUserServiceState = {
  sessionKeeperTimeout: undefined,
  localStorageAvailable: true
}
